/*
 * @Author: zhengshuhua
 * @Date: 2022-03-14 16:40:20
 * @LastEditors: zhengshuhua
 * @LastEditTime: 2022-09-30 09:45:19
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\request\api\canlender.js
 */
import { get } from '../axios'
const canlender = {
	// 日历获取访视名称
	getVisitName: (date, openId) => get(`/web/weixin/queryCalendar/${date}/${openId}`)
}
export default canlender